"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonTheme = SkeletonTheme;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _SkeletonThemeContext = require("./SkeletonThemeContext");
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function SkeletonTheme(_a) {
  var {
      children
    } = _a,
    styleOptions = __rest(_a, ["children"]);
  return (0, _jsxRuntime.jsx)(_SkeletonThemeContext.SkeletonThemeContext.Provider, (0, _extends2["default"])({
    value: styleOptions
  }, {
    children: children
  }));
}